import { CSSProperties } from "react";

import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";

const offsetByShape: Record<
  Exclude<
    MarkerShape,
    | MarkerShape.LEAD
    | MarkerShape.LEAD_CLICKED
    | MarkerShape.LEAD_DUPLICATE
    | MarkerShape.LEAD_DUPLICATE_CLICKED
    | MarkerShape.LEAD_HIDDEN
    | MarkerShape.LEAD_HIDDEN_CLICKED
    | MarkerShape.LEAD_SELECTED
    | MarkerShape.TRIP_FINISH
    | MarkerShape.TRIP_START
  >,
  [number, number]
> = {
  [MarkerShape.BOOKMARK]: [10, 7],
  [MarkerShape.CIRCLE]: [10, 8],
  [MarkerShape.FLAG]: [12, 6],
  [MarkerShape.HEART]: [11, 8],
  [MarkerShape.HEXAGON]: [10, 9],
  [MarkerShape.PIN]: [10, 7],
  [MarkerShape.SQUARE]: [10, 8],
  [MarkerShape.STAR]: [10, 10],
  [MarkerShape.TRIANGLE]: [10, 11],
};

const getEditIconPositionByShape = (shape?: MarkerShape): CSSProperties => {
  const [left, top] =
    shape && shape in offsetByShape
      ? offsetByShape[
          shape as Exclude<
            MarkerShape,
            | MarkerShape.LEAD
            | MarkerShape.LEAD_CLICKED
            | MarkerShape.LEAD_DUPLICATE
            | MarkerShape.LEAD_DUPLICATE_CLICKED
            | MarkerShape.LEAD_HIDDEN
            | MarkerShape.LEAD_HIDDEN_CLICKED
            | MarkerShape.LEAD_SELECTED
            | MarkerShape.TRIP_FINISH
            | MarkerShape.TRIP_START
          >
        ]
      : [undefined, undefined];
  return {
    left: left ? `${left}px` : "50%",
    top: top ? `${top}px` : "50%",
  };
};

export default getEditIconPositionByShape;
